import { createContext } from "react";

interface SidebarContextValue {
	open: boolean;
	toggleSidebar: () => void;
}

export const SidebarContext = createContext<SidebarContextValue>(null as any);
